import React, { useState, useEffect, useMemo } from 'react';
import { Chart } from 'react-google-charts';
import api from './AxiosConfig';
import date from 'date-and-time'; // Moved import to top

function ReviewGoalDQT(props) {
  const [progress, setProgress] = useState();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getGoalProgress = async () => {
      if (props?.goal?.id && !loaded) {
        try {
          const goalProgress = await api.get(`/site/goals/progress/${encodeURIComponent(props.goal.id)}`, { withCredentials: true });
          setProgress(goalProgress.data);
          setLoaded(true);
        } catch (error) {
          console.log("ReviewGoalDQT: " + error);
        }
      }
    };
    getGoalProgress();
  }, [loaded, props.goal?.id]); // Narrowed deps for efficiency

  // Compute graphData during render (or memoize if expensive)
  const graphData = useMemo(() => {
    const data = [["Date", "Target", "Inst Target", "Actual", "Trend (" + (props.goal?.dqt_predicted_date?.split('T')[0] ?? '') + ")"]];

    if (progress && progress.length > 0) {
      for (const el of progress) {
        const ds = date.format(new Date(el.date), "DD/MM");
        const tg = el.target_value;
        const tr = el.linear_trend;
        const ac = el.value ?? NaN;
        const it = el.instant_target ?? NaN;
        data.push([ds, tg, it, ac, tr]);
      }
    }
    return data;
  }, [progress, props.goal?.dqt_predicted_date]); // Recompute only when these change

  // Compute summary as a variable (derived from progress and props)
  let summary = "To be completed.";
  if (progress && progress.length > 0) {
    // Assuming delta is calculated in graphData loop; for simplicity, recompute here or extract to a function
    const lt1 = progress[progress.length - 1].instant_target;
    const lt2 = progress[progress.length - 2].instant_target;
    const delta = (lt2 - lt1);
    const decreasing = props.goal.dqt_target_value < props.goal.dqt_start_value;
    summary = "To achieve your target you need to ";
    summary += decreasing ? `lose ${delta.toFixed(2)} ${props.goal.dqt_units} per ` : `gain ${Number(-1 * delta).toFixed(2)} ${props.goal.dqt_units} per `;
    summary += `${props.goal.sample_period} days. The current average predicts that you will achieve the target on ${props.goal.dqt_predicted_date.split('T')[0]}.`;
  }

  // Chart options (can stay as-is, or memoize if props change often)
  const options = {
    title: 'Achievement - ' + (props.goal?.goal_title ?? ''),
    curveType: "function",
    legend: { position: "bottom" },
    colors: ["#0000DF", "#ff0000", "#FFBF00", "#606060"],
    series: {
      0: { lineDashStyle: [0], lineWidth: 3 },
      1: { lineDashStyle: [0], lineWidth: 3 },
      2: { lineDashStyle: [0], lineWidth: 3 },
      3: { lineDashStyle: [4, 4], lineWidth: 2 },
    },
    chartArea: { border: '1px solid black', borderRadius: '10px' },
    hAxis: { title: 'Date' },
    vAxis: { title: 'Progress' },
  };

  return (
    <div>
      {loaded ? (
        <>
          <div className="dqt-summary">{summary}</div>
          <Chart chartType="LineChart" width="100%" height="600px" data={graphData} options={options} />
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ReviewGoalDQT;
